import { createFeatureSelector } from '@ngrx/store';
import { State } from './index';

export enum SortOrders {
  ASC = 'asc',
  DESC = 'desc',
}

export const defaultItemsPerPage = 20;

export const getFeatureState = createFeatureSelector<State>('manage');
